module.exports = __webpack_public_path__ + "static/media/builder.6959e40c.svg";